export default __webpack_public_path__ + "static/media/vsxp.b4a90bb0.png";